import Hero from "../../components/Home/Hero";
import LogoSlider from "../../components/Home/LogoSlider";
import Reveal from "../../components/ui/Reveal";
import styles from "./page.module.css";
import { Link } from "react-router-dom";

export default function Home() {
  const partners = [
    { name: "Toray Innovation by Chemistry", logo: "https://infinity-et.com/wp-content/uploads/2025/04/IATS_Company_Profile_14.05.jpg" },
    { name: "Schiller – The Art of Diagnostics", logo: "https://infinity-et.com/wp-content/uploads/2025/04/IATS_Company_Profile_14.05hsd.jpg" },
    { name: "Radiometer", logo: "https://infinity-et.com/wp-content/uploads/2025/04/images.png" },
    { name: "STORZ Endoskope", logo: "https://infinity-et.com/wp-content/uploads/2025/04/Karl_Storz_Endoskope_logo.svg.png" },
    { name: "Leica Biosystems", logo: "https://infinity-et.com/wp-content/uploads/2025/04/Leica_Biosystems_Logo.jpg" },
    { name: "Carestream", logo: "https://infinity-et.com/wp-content/uploads/2025/04/logo_master_brand_mark_hires.jpg" },
    { name: "Sturdy Medical", logo: "https://infinity-et.com/wp-content/uploads/2025/04/sturdy2-logo-300x113-1.png" },
    { name: "Terumo", logo: "https://infinity-et.com/wp-content/uploads/2025/04/Terumo.svg.png" },
    { name: "Thermo Fisher Scientific", logo: "https://infinity-et.com/wp-content/uploads/2025/04/Thermo_Fisher_Scientific_logo.svg.png" },
    { name: "Oracle", logo: "https://infinity-et.com/wp-content/uploads/2025/04/IMG_0006.png" },
  ];

  const services = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shield text-primary" data-loc="client/src/components/InvestmentThesis.tsx:74"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>
      ),
      title: "Authorized GE Healthcare Partner",
      description: "Exclusive distribution and service partnership with GE Healthcare for Ethiopia and Kenya — providing access to world-class imaging, diagnostics, and surgical systems.",
      href: "/healthcare-technology",
      color: "#003087",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-wrench text-primary" data-loc="client/src/components/InvestmentThesis.tsx:74"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
      ),
      title: "Full Lifecycle Coverage",
      description: "From equipment procurement through installation, calibration, maintenance, spare parts, and training — a single partner for the entire asset lifecycle. ISO 9001 certified.",
      href: "/services",
      color: "#1565C0",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-trending-up text-primary" data-loc="client/src/components/InvestmentThesis.tsx:74"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>),
      title: "Recurring Revenue Streams",
      description: "Annual maintenance contracts, spare parts, consumables, and calibration services create predictable, high-retention revenue beyond one-time equipment sales.",
      href: "/services",
      color: "#0099CC",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-zap text-primary" data-loc="client/src/components/InvestmentThesis.tsx:74"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path></svg>
      ),
      title: "Critical Infrastructure Role",
      description: "Healthcare facilities depend on equipment uptime for patient care. This creates strong long-term partnerships and trust across 4,000+ installations.",
      href: "/services",
      color: "#006B9F",
    },
  ];

  const reasons = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" /><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" /><path d="M4 22h16" /><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" /><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" /><path d="M18 2H6v7a6 6 0 0 0 12 0V2z" /></svg>
      ),

      title: "GE HealthCare Authorized",
      description: "GE HealthCare Authorized partner delivering MRI, CT, Cath Labs, Ultrasound, and X-Ray solutions.",
      accent: "#003087",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>
      ),
      title: "Global Partners",
      description: "Local Execution.Infinity collaborates with internationally recognized medical technology manufacturers.",
      accent: "#1565C0",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>
      ),
      title: "Strategic Partnerships",
      description: "Additional strategic partnerships support imaging, oncology, surgery, laboratory solutions, and healthcare infrastructure.",
      accent: "#0099CC",
    },
  ];
  const revenueModels = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-package text-primary" data-loc="client/src/components/RevenueModel.tsx:95"><path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"></path><path d="M12 22V12"></path><path d="m3.3 7 7.703 4.734a2 2 0 0 0 1.994 0L20.7 7"></path><path d="m7.5 4.27 9 5.15"></path></svg>
      ),
      title: "Equipment Distribution",
      description: "Large-ticket medical equipment sales through OEM partnerships.",
      href: "/#",
      color: "#003087",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-cog text-primary" data-loc="client/src/components/RevenueModel.tsx:95"><path d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"></path><path d="M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"></path><path d="M12 2v2"></path><path d="M12 22v-2"></path><path d="m17 20.66-1-1.73"></path><path d="M11 10.27 7 3.34"></path><path d="m20.66 17-1.73-1"></path><path d="m3.34 7 1.73 1"></path><path d="M14 12h8"></path><path d="M2 12h2"></path><path d="m20.66 7-1.73 1"></path><path d="m3.34 17 1.73-1"></path><path d="m17 3.34-1 1.73"></path><path d="m11 13.73-4 6.93"></path></svg>
      ),
      title: "Installation & Commissioning",
      description: "Site preparation, equipment installation, calibration, and handover.",
      href: "/#",
      color: "#003087",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-repeat text-primary" data-loc="client/src/components/RevenueModel.tsx:95"><path d="m17 2 4 4-4 4"></path><path d="M3 11v-1a4 4 0 0 1 4-4h14"></path><path d="m7 22-4-4 4-4"></path><path d="M21 13v1a4 4 0 0 1-4 4H3"></path></svg>
      ),
      title: "Annual Maintenance Contracts",
      description: "Predictable annual revenue with high retention rates.",
      href: "/#",
      color: "#003087",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shopping-cart text-primary" data-loc="client/src/components/RevenueModel.tsx:95"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>
      ),
      title: "Spare Parts & Consumables",
      description: "Repeat-purchase revenue from the insalled equipment base.",
      href: "/#",
      color: "#003087",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-stethoscope text-primary" data-loc="client/src/components/RevenueModel.tsx:95"><path d="M11 2v2"></path><path d="M5 2v2"></path><path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1"></path><path d="M8 15a6 6 0 0 0 12 0v-3"></path><circle cx="20" cy="10" r="2"></circle></svg>
      ),
      title: "Calibration & Compliance",
      description: "Mandatory technical services for safety and regulatory compliance.",
      href: "/#",
      color: "#003087",
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-graduation-cap text-primary" data-loc="client/src/components/RevenueModel.tsx:95"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"></path><path d="M22 10v6"></path><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path></svg>
      ),
      title: "Clinical Training",
      description: "Operator training that strengthens customer engagement and service quality.",
      href: "/#",
      color: "#003087",
    },
  ]
  return (<>
    <Hero />
    {/* ── Services ─────────────────────── */}
    <section className={styles.servicesSection}>
      {/* Decorative blob */}
      <div className={styles.blob1} aria-hidden />
      <div className={styles.container}>
        <Reveal>
          <div className={styles.sectionHead}>
            <span className={styles.label}>Why Infinity</span>
            <h2 className={styles.h2}>A Healthcare Technology Platform, Not Just a Supplier</h2>
            <p className={styles.subtext}>
              Infinity operates as a healthcare technology infrastructure partner in Ethiopia and Kenya, combining GE Healthcare equipment distribution, turnkey installation, lifecycle maintenance, spare parts, consumables, and clinical training into a single integrated platform.
            </p>
          </div>
        </Reveal>

        <div className={styles.servicesGrid}>
          {services.map((s, i) => (
            <Reveal key={i} delay={i * 80}>
              <Link to={s.href} className={styles.serviceCard}>
                <div className={styles.serviceIconWrap} style={{ background: `${s.color}18`, color: s.color }}>
                  {s.icon}
                </div>
                <h3 className={styles.serviceTitle}>{s.title}</h3>
                <p className={styles.serviceDesc}>{s.description}</p>
                <span className={styles.serviceArrow}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
                </span>
                <div className={styles.cardGlow} style={{ background: `radial-gradient(circle at 50% 0%, ${s.color}14 0%, transparent 70%)` }} />
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    {/* ── Partners ─────────────────────── */}
    <section className={styles.partnersSection}>
      <div className={styles.container}>


        <Reveal>
          <div className={styles.sectionHead}>
            <span className={styles.label}>Trusted Partners</span>
            <h2 className={styles.h2}>Partners</h2>
            <LogoSlider items={partners} />

          </div>

        </Reveal>
        <div className={styles.partnerGrid}>
          {reasons.map((r, i) => (
            <Reveal key={i} delay={i * 100}>
              <div className={styles.card}>
                <div className={styles.iconWrap} style={{ background: `${r.accent}25`, color: r.accent }}>
                  {r.icon}
                </div>
                <h3 className={styles.title}>{r.title}</h3>
                <p className={styles.desc}>{r.description}</p>
              </div>
            </Reveal>
          ))}
        </div>

      </div>



    </section>

    {/* ── CTA Banner ───────────────────── */}
    <section className={styles.ctaSection}>
      <div className={styles.ctaNoise} aria-hidden />
      <div className={styles.container}>
        <Reveal>
          <h2 className={styles.ctaTitle}>Let&apos;s Connect</h2>
          <p className={styles.ctaDesc}>
            Whether you&apos;re an OEM manufacturer, healthcare institution, development finance organization, or strategic partner, we&apos;d welcome the opportunity to explore how we can work together.
          </p>
          <div className={styles.ctaBtns}>
            <Link to="/contact" className={styles.ctaPrimary}>Get in Touch</Link>
            <Link to="/about" className={styles.ctaOutline}>About Us</Link>
          </div>
        </Reveal>
      </div>
    </section>
  </>
  );
}